var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "-0.5 -0.5 11 11",
    fill: "none",
    overflow: "visible",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 4,
    fill: "#0A6F85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08061 8V2.18182H5.15447C5.60713 2.18182 5.98213 2.2642 6.27947 2.42898C6.57682 2.59375 6.79936 2.81913 6.94709 3.10511C7.09482 3.3892 7.16868 3.70928 7.16868 4.06534C7.16868 4.4233 7.09387 4.74527 6.94425 5.03125C6.79652 5.31534 6.57304 5.54072 6.27379 5.70739C5.97644 5.87216 5.60239 5.95455 5.15163 5.95455H3.7255V5.21023H5.07209C5.35807 5.21023 5.59008 5.16098 5.76811 5.0625C5.94614 4.96212 6.07682 4.82576 6.16016 4.65341C6.24349 4.48106 6.28516 4.28504 6.28516 4.06534C6.28516 3.84564 6.24349 3.65057 6.16016 3.48011C6.07682 3.30966 5.94519 3.17614 5.76527 3.07955C5.58724 2.98295 5.35239 2.93466 5.06072 2.93466H3.95845V8H3.08061Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerLocation);
export default __webpack_public_path__ + "static/media/PartnerLocation.9c6963dc102293c0d7b4f8a99445243d.svg";
export { ForwardRef as ReactComponent };